import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { PartnerEmployeeNotificationInterface } from '../definitions/partner-employee-notification.interface';

@Injectable()
export class EnablePartnerEmployeeNotificationService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public enableNotification(partnerEmployeeNotification: PartnerEmployeeNotificationInterface): Observable<any> {
    const url = `${this.configService.config.rest.apiV2Url}/partners/${partnerEmployeeNotification.partnerId}/notifications/${partnerEmployeeNotification.notifyEmailType}/employees/${partnerEmployeeNotification.employeeId}`;

    return this.client.put(url, {})
    .pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}